module.exports = __webpack_public_path__ + "static/media/registeredPlayers.e11f72b2.svg";